import { render, staticRenderFns } from "./supply.vue?vue&type=template&id=6263c698&"
import script from "./supply.vue?vue&type=script&lang=js&"
export * from "./supply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports